/* You Fly LA kit (yk-) v66 :: yk-book.js :: built from kit/src */
/* --- 10-book-00-base.js --- */
/* =====================================================================
   YFLA KIT, group "book" (KB1-BOOK, v66). Run-once guard + shared helpers.
   Each 10-book-*.js file guards itself with its own flag on window.YK_book,
   so the group is safe to load twice (two yk-assets renders on one page).
   Elements register with YK.reg('<el>', fn) from 00-core.js. If the core is
   not on the page (the homepage does not load it) the HTML stays complete
   and nothing runs.
   ===================================================================== */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.base) return;
  B.base = 1;

  /* Run fn(YK) once the core registry exists (both are deferred, so it normally already does). */
  B.ready = function (fn) {
    if (window.YK && window.YK.reg) { fn(window.YK); return; }
    document.addEventListener('DOMContentLoaded', function () { if (window.YK && window.YK.reg) fn(window.YK); });
  };

  /* Single-select toggle group: set aria-pressed on the button whose data-v === v. */
  B.press = function (buttons, v) {
    buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === v)); });
  };

  /* Show the child whose [data-key] === v, hide its siblings (toggle with [hidden]). */
  B.show = function (nodes, attr, v) {
    nodes.forEach(function (n) { n.hidden = n.getAttribute(attr) !== String(v); });
  };

  /* Time in America/Los_Angeles: {mins: minutes since local midnight, h12, mm, ap} */
  B.la = function (d) {
    d = d || new Date();
    var p = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: '2-digit', hour12: true })
        .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      var h24 = parseInt(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', hourCycle: 'h23' }).format(d), 10) % 24;
      var mm = parseInt(p.minute, 10) || 0;
      return { mins: h24 * 60 + mm, h12: p.hour, mm: p.minute, ap: (p.dayPeriod || (h24 < 12 ? 'AM' : 'PM')).toUpperCase() };
    } catch (e) { return null; }
  };
})();

/* --- 10-book-bookbar.js --- */
/* yk-bookbar: shows after the first screen (or at rest with at=rest), hides while the footer or any
   form is near the viewport and while a text field has focus (phone keyboards). Only the first
   yk-bookbar on a page is used; it also hides the theme's mobile CTA bar (html.yk-has-bookbar), so
   two bars never show. Never touches scroll position. */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.bookbar) return;
  B.bookbar = 1;

  /* forms the bar must not cover: page forms only (not search, not the theme's pop-ups, not the header) */
  var SKIP = '#header-group, header, footer, .shopify-section-group-footer-group, .yk-bookbar, #yfla-em, #yfla-cm, #yfla-gate, [role="dialog"], dialog';
  function isPageForm(f) {
    if (f.closest(SKIP)) return false;
    var act = (f.getAttribute('action') || '').toLowerCase();
    return act.indexOf('/search') === -1 && f.getAttribute('role') !== 'search';
  }

  B.ready(function (YK) {
    YK.reg('bookbar', function (el, o) {
      var first = YK.qs('.yk-bookbar');
      if (first !== el) { el.hidden = true; return; }
      document.documentElement.classList.add('yk-has-bookbar');
      var near = 0, foot = false, focusIn = false, past = o.at === 'rest', on = null;
      var seen = typeof Map === 'function' ? new Map() : null;
      /* QA-V66: the footer is a sticky "curtain" behind <main> (always inside the viewport, clipped), so an
         IntersectionObserver on it always reports "near". The footer is near when the end of <main> is. */
      var main = document.getElementById('MainContent') || document.querySelector('main');

      function update() {
        var show = past && !foot && near === 0 && !focusIn;
        if (show === on) return;
        on = show;
        el.classList.toggle('is-on', show);
        document.documentElement.classList.toggle('yk-bookbar-on', show);
      }
      function onScroll() {
        var p = o.at === 'rest' || (YK.scrollY ? YK.scrollY() : (window.scrollY || window.pageYOffset || 0)) > window.innerHeight * 0.85;
        var f = !!main && main.getBoundingClientRect().bottom < window.innerHeight + 160;
        if (p !== past || f !== foot) { past = p; foot = f; update(); }
      }
      if ('IntersectionObserver' in window && seen) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
          near = 0; seen.forEach(function (v) { if (v) near += 1; });
          update();
        }, { rootMargin: '0px 0px 160px 0px', threshold: 0 });
        YK.qsa('form').forEach(function (f) { if (isPageForm(f)) io.observe(f); });
      }
      document.addEventListener('focusin', function (e) {
        var t = e.target;
        focusIn = !!(t && t.matches && t.matches('input:not([type=button]):not([type=submit]):not([type=checkbox]):not([type=radio]):not([type=range]), textarea, select') && !el.contains(t));
        update();
      });
      document.addEventListener('focusout', function () { setTimeout(function () { if (!document.activeElement || document.activeElement === document.body) { focusIn = false; update(); } }, 0); });
      if (YK.onScroll) YK.onScroll(onScroll); else window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
      update();
    });
  });
})();

/* --- 10-book-calc.js --- */
/* yk-calc: Flight Cost Calculator (designs 05 / 03). Each upgrade hour replaces one standard aircraft
   hour, so DA20 + Cirrus hours are bounded by the package's standard-rate aircraft hours
   (content.json calculator.standard_rate_hours_per_package). Rates: +$50 / +$270 per hour. */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.calc) return;
  B.calc = 1;

  B.ready(function (YK) {
    YK.reg('calc', function (el) {
      var sel = YK.qs('.yk-calc__sel', el);
      var ups = YK.qsa('.yk-calc__up', el);
      var rate = {}, hrsUp = {};
      ups.forEach(function (u) { var k = u.getAttribute('data-up'); rate[k] = +u.getAttribute('data-rate'); hrsUp[k] = 0; });
      var q = function (s) { return YK.qs('[data-sum="' + s + '"]', el); };
      var enroll = YK.qs('[data-calc-enroll]', el);

      function opt() { return sel.options[sel.selectedIndex]; }
      function render() {
        var o = opt(), hrs = +o.getAttribute('data-hrs'), base = +o.getAttribute('data-price');
        /* clamp to the package's standard hours (Cirrus gives way first, as in design 05) */
        hrsUp.d = YK.clamp(hrsUp.d, 0, hrs);
        hrsUp.c = YK.clamp(hrsUp.c, 0, hrs - hrsUp.d);
        var used = hrsUp.d + hrsUp.c;
        var total = base + hrsUp.d * rate.d + hrsUp.c * rate.c;
        q('std').textContent = (hrs - used) + ' of ' + hrs + ' aircraft hours at the standard rate · ' + used + ' upgraded';
        q('pkg').textContent = o.getAttribute('data-name');
        q('dh').textContent = hrsUp.d; q('ch').textContent = hrsUp.c;
        q('dv').textContent = '+' + YK.money(hrsUp.d * rate.d);
        q('cv').textContent = '+' + YK.money(hrsUp.c * rate.c);
        q('tot').textContent = YK.money(total);
        ups.forEach(function (u) {
          var k = u.getAttribute('data-up');
          YK.qs('[data-out]', u).textContent = hrsUp[k];
          YK.qsa('[data-step]', u).forEach(function (b) {
            b.disabled = +b.getAttribute('data-d') < 0 ? hrsUp[k] <= 0 : used >= hrs;
          });
        });
        if (enroll) {
          enroll.setAttribute('data-pick', o.getAttribute('data-prog'));
          var pkg = o.getAttribute('data-full') || o.textContent.trim();
          if (used) pkg += ' · ' + hrsUp.d + ' hrs Diamond DA20-C1 · ' + hrsUp.c + ' hrs Cirrus SR22 Turbo · Total ' + YK.money(total);
          enroll.setAttribute('data-pkg', pkg);
        }
      }
      sel.addEventListener('change', function () { render(); YK.track('calc_package', sel.value); });
      el.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-step]');
        if (!b || !el.contains(b) || b.disabled) return;
        var k = b.getAttribute('data-step');
        hrsUp[k] = Math.max(0, hrsUp[k] + (+b.getAttribute('data-d')));
        render();
        /* keep focus usable when the button just pressed becomes disabled */
        if (b.disabled) { var other = YK.qs('[data-step="' + k + '"]:not([disabled])', el); if (other) other.focus(); }
      });
      render();
    });
  });
})();

/* --- 10-book-discovery.js --- */
/* yk-discovery: design 04 pick-your-flight. Filters (who, airplane, time of day, length) dim the five
   options and move the selection to the first match; a chip that would leave nothing to pick is
   disabled. Time of day swaps the tip line (design 04). Duration buttons pick the price and which
   pre-rendered "Choose Your Time" link shows (links are never rewritten by JS, so the theme's
   calendar rewrite in yfla-book.js and its consent gate keep working on them). */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.discovery) return;
  B.discovery = 1;

  B.ready(function (YK) {
    YK.reg('discovery', function (el, o) {
      var opts = YK.qsa('.yk-discovery__opt', el);
      var items = YK.qsa('.yk-discovery__item', el);
      var groups = {};
      YK.qsa('[data-f]', el).forEach(function (g) { groups[g.getAttribute('data-f')] = YK.qsa('[data-v]', g); });
      var tips = YK.qsa('.yk-discovery__tip', el);
      var st = { opt: o.focus || 'two', who: 'any', ac: 'any', tod: 'morning', len: '60' };
      opts.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') st.opt = b.getAttribute('data-opt'); });

      function optEl(id) { return opts.filter(function (b) { return b.getAttribute('data-opt') === id; })[0]; }
      function matches(b, who, ac) {
        var w = (b.getAttribute('data-who') || '').split(' ');
        return (who === 'any' || w.indexOf(who) > -1) && (ac === 'any' || b.getAttribute('data-ac') === ac);
      }
      function anyMatch(who, ac) { return opts.some(function (b) { return matches(b, who, ac); }); }
      function pax(id) { return id === 'lux' && st.who === 'two' ? '1' : '0'; }

      function render() {
        /* filters */
        ['who', 'ac', 'tod', 'len'].forEach(function (f) { if (groups[f]) B.press(groups[f], st[f]); });
        groups.who.forEach(function (c) { c.disabled = c.getAttribute('data-v') !== 'any' && !anyMatch(c.getAttribute('data-v'), st.ac); });
        groups.ac.forEach(function (c) { c.disabled = c.getAttribute('data-v') !== 'any' && !anyMatch(st.who, c.getAttribute('data-v')); });
        B.show(tips, 'data-tod', st.tod);
        /* options: dim, keep the selection on a match */
        var cur = optEl(st.opt);
        if (cur && !matches(cur, st.who, st.ac)) {
          var first = opts.filter(function (b) { return matches(b, st.who, st.ac); })[0];
          if (first) st.opt = first.getAttribute('data-opt');
        }
        opts.forEach(function (b) {
          var id = b.getAttribute('data-opt');
          b.setAttribute('aria-pressed', String(id === st.opt));
          b.toggleAttribute('data-dim', !matches(b, st.who, st.ac));
        });
        /* stage: the selected flight, its duration and price set (one flyer / with a passenger) */
        B.show(items, 'data-opt', st.opt);
        items.forEach(function (it) {
          var id = it.getAttribute('data-opt'), px = pax(id);
          var durs = YK.qsa('.yk-discovery__durs button', it);
          var lens = durs.map(function (d) { return d.getAttribute('data-dur'); });
          var len = lens.indexOf(st.len) > -1 ? st.len : lens[0];
          var on = durs[lens.indexOf(len)];
          durs.forEach(function (d) {
            d.setAttribute('aria-pressed', String(d === on));
            YK.qsa('[data-px]', d).forEach(function (p) { p.hidden = p.getAttribute('data-px') !== px; });
          });
          var price = YK.qs('[data-px="' + px + '"]', on).textContent;
          YK.qs('[data-bigp]', it).textContent = price;
          YK.qs('[data-bigd]', it).textContent = on.querySelector('span').textContent + (px === '1' ? ' · Bring A Passenger' : '');
          YK.qsa('.yk-discovery__cta', it).forEach(function (a) {
            a.hidden = !(a.getAttribute('data-dur') === len && a.getAttribute('data-px') === px);
          });
          /* option list price follows the chosen length (and the passenger price for the Cirrus) */
          var ob = optEl(id);
          if (ob) YK.qs('[data-op]', ob).textContent = price;
        });
      }

      el.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target : null;
        if (!t) return;
        var chip = t.closest('[data-f] [data-v]');
        if (chip && el.contains(chip) && !chip.disabled) {
          var f = chip.parentNode.getAttribute('data-f');
          st[f] = chip.getAttribute('data-v');
          render(); YK.track('discovery_filter', f + '=' + st[f]); return;
        }
        var ob = t.closest('.yk-discovery__opt');
        if (ob && el.contains(ob)) {
          st.opt = ob.getAttribute('data-opt');
          /* picking a flight that the filters exclude clears those filters */
          if (!matches(ob, st.who, st.ac)) { st.who = 'any'; st.ac = 'any'; }
          render(); YK.track('discovery_option', st.opt); return;
        }
        var d = t.closest('.yk-discovery__durs button');
        if (d && el.contains(d)) { st.len = d.getAttribute('data-dur'); render(); YK.track('discovery_length', st.len); }
      });
      render();
    });
  });
})();

/* --- 10-book-flightplan.js --- */
/* yk-flightplan: design 01 Flight Plan panel. Every goal's readouts, first step and fine print are
   pre-rendered in the snippet; JS toggles the goal and recomputes the months estimate:
   months = max(1, loggedHours / (lessonsPerWeek x 1.5) / 4), one decimal (design 01's formula). */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.flightplan) return;
  B.flightplan = 1;

  function months(hours, lpw) {
    var m = Math.max(1, hours / (lpw * 1.5) / 4);
    return (Math.round(m * 10) / 10).toFixed(1).replace(/\.0$/, '');
  }

  B.ready(function (YK) {
    YK.reg('flightplan', function (el, o) {
      var seg = YK.qsa('.yk-flightplan__seg [data-v]', el);
      var goals = YK.qsa('.yk-flightplan__goal', el);
      var range = YK.qs('input[type=range]', el);
      var out = YK.qs('[data-fp-out]', el);
      var tag = YK.qs('[data-fp-tag]', el);
      var goal = o.goal || 'ppl';

      function render() {
        var lpw = +range.value || 2;
        var txt = lpw + (lpw === 1 ? ' Lesson / Week' : ' Lessons / Week');
        out.textContent = txt;
        range.setAttribute('aria-valuetext', txt);
        YK.fill(range);
        B.press(seg, goal);
        B.show(goals, 'data-goal', goal);
        var on = seg.filter(function (b) { return b.getAttribute('data-v') === goal; })[0];
        if (on) tag.textContent = on.getAttribute('data-tag');
        range.disabled = goal === 'fly-once';
        goals.forEach(function (g) {
          var hours = +g.getAttribute('data-hours');
          var m = YK.qs('[data-fp-months]', g);
          if (!hours || !m) return;
          var typ = g.getAttribute('data-typ');
          m.firstChild.nodeValue = months(hours, lpw);
          var sub = m.parentNode.querySelector('.yk-flightplan__s');
          if (sub) sub.textContent = 'At ' + lpw + ' lesson' + (lpw > 1 ? 's' : '') + ' a week.' + (typ ? ' ' + typ + '.' : '');
        });
      }

      seg.forEach(function (b) {
        b.addEventListener('click', function () {
          goal = b.getAttribute('data-v');
          render();
          YK.track('flightplan_goal', goal);
        });
      });
      range.addEventListener('input', render);
      range.addEventListener('change', function () { YK.track('flightplan_schedule', range.value); });
      render();
    });
  });
})();

/* --- 10-book-lessonpick.js --- */
/* yk-lessonpick: Airplane x One Or Two -> one of the five live beginner lessons. The lesson for two
   exists only in the Piper Warrior, so choosing "Me + A Guest" moves the airplane to the trainer and
   choosing the DA20, the Cirrus or the simulator moves back to "Just Me" (a polite note says so).
   Every card and link is pre-rendered; JS only toggles [hidden] and aria-pressed. */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.lessonpick) return;
  B.lessonpick = 1;

  var NOTE = 'Lesson For Two Flies The Piper Warrior Only';

  B.ready(function (YK) {
    YK.reg('lessonpick', function (el) {
      var chips = YK.qsa('.yk-chip[data-k]', el);
      var cards = YK.qsa('.yk-lessonpick__card', el);
      var phs = YK.qsa('.yk-lessonpick__ph', el);
      var note = YK.qs('[data-lp-note]', el);
      var cur = cards.filter(function (c) { return !c.hidden; })[0] || cards[0];
      var st = { ac: cur.getAttribute('data-ac'), who: cur.getAttribute('data-who') };

      function lessonFor() {
        return cards.filter(function (c) { return c.getAttribute('data-ac') === st.ac && c.getAttribute('data-who') === st.who; })[0];
      }
      function render() {
        var c = lessonFor() || cards[0];
        var id = c.getAttribute('data-lesson');
        B.show(cards, 'data-lesson', id);
        B.show(phs, 'data-lesson', id);
        B.press(chips.filter(function (b) { return b.getAttribute('data-k') === 'ac'; }), st.ac);
        B.press(chips.filter(function (b) { return b.getAttribute('data-k') === 'who'; }), st.who);
      }
      chips.forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
          var msg = '';
          if (k === 'len') return;
          st[k] = v;
          if (k === 'who' && v === 'two' && st.ac !== 'trainer') { st.ac = 'trainer'; msg = NOTE; }
          if (k === 'ac' && v !== 'trainer' && st.who === 'two') { st.who = 'one'; msg = NOTE; }
          note.textContent = msg;
          render();
          YK.track('lessonpick', st.ac + '/' + st.who);
        });
      });
      render();
    });
  });
})();

/* --- 10-book-today.js --- */
/* yk-today: live America/Los_Angeles clock (Intl) and Open Now / Closed Now with the next change,
   computed from each row's published hours (data-open / data-close, minutes after local midnight;
   every day of the week). Updates every 15 s; the status line is only rewritten when it changes. */
(function () {
  'use strict';
  var B = window.YK_book = window.YK_book || {};
  if (B.today) return;
  B.today = 1;

  function fmt(mins) {
    var h = Math.floor(mins / 60), m = mins % 60, ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }
  /* -> {open, text} for one row at local minute t */
  B.hours = function (t, a, b) {
    if (t >= a && t < b) return { open: true, text: 'Open Now · Closes ' + fmt(b) };
    if (t < a) return { open: false, text: 'Closed Now · Opens ' + fmt(a) };
    return { open: false, text: 'Closed Now · Opens Tomorrow ' + fmt(a) };
  };

  B.ready(function (YK) {
    YK.reg('today', function (el) {
      var tEl = YK.qs('[data-t]', el), apEl = YK.qs('[data-ap]', el), stEl = YK.qs('[data-st]', el);
      var rows = YK.qsa('.yk-today__rows li', el);
      var last = '';
      function tick() {
        var now = B.la(new Date());
        if (!now) return;
        tEl.textContent = now.h12 + ':' + now.mm;
        apEl.textContent = now.ap + ' PT';
        rows.forEach(function (r) {
          var s = B.hours(now.mins, +r.getAttribute('data-open'), +r.getAttribute('data-close'));
          var em = YK.qs('[data-rst]', r);
          var short = s.open ? s.text.replace('Open Now · Closes', 'Open Now · Until') : s.text.replace('Closed Now · ', '');
          if (em.textContent !== short) em.textContent = short;
          em.toggleAttribute('data-open', s.open);
          if (r.hasAttribute('data-main') && s.text !== last) {
            last = s.text;
            stEl.textContent = s.text;
            stEl.toggleAttribute('data-closed', !s.open);
          }
        });
      }
      tick();
      setInterval(tick, 15000);
    });
  });
})();
